import { PROFILE_CLASS_NAME } from '../../../models/profile/constants'
import { USER_CLASS_NAME } from '../../user/model/constants'

const REDUX_NON_DELETABLE = [
  PROFILE_CLASS_NAME,
  USER_CLASS_NAME
]

export default REDUX_NON_DELETABLE
